module.exports = __webpack_public_path__ + "img/SV.919719c1.svg";